import React, { useEffect, useState } from 'react'
import Header from '../Header'
import HeaderComp from '../HeaderComp/HeaderComp'
// import HeaderComp1 from '../HeaderComp1/HeaderComp1'
// import NavbarComp from '../NavBarComp/NavbarComp'
// import NavBarSearchBar from '../NavBarSearchBar'
import MerchantSiteNav from './MerchantSiteNav'
import styled from 'styled-components'
import MerchantSiteHeader from './MerchantSiteHeader'
import axios from 'axios'
import { NavLink, useParams } from 'react-router-dom'

const MerchantSite = () => {
  const [logoData, setLogoData] = useState(null);
  const [merchantData, setMerchantData] = useState(null);
  const {merchantid} = useParams()
  // console.log(merchantData,"merchantsite")
  // alert(merchantId)
  
  useEffect(() => {
    // 
    setMerchantData(merchantid)
      }, []);

      useEffect(() => {
      if (merchantData) {
        axios
          .get(`https://api.bakpoket.com/api/MerchantPage/GetMerchantStore/${merchantData}`)
          .then((res) => {
            setLogoData(res.data);
          })
          .catch((err) => console.log(err));
      }
    }, [merchantData]);


    // useEffect(()=>{
    //     axios
    //     .get('https://api.bakpoket.com/api/MerchantPage/GetMerchantStore/6')
    //     .then(res => {
    //       setLogoData(res.data);
    //     })
  
    //     .catch(err => console.log(err))
    // },[]);
  return (
    <Wrapper>
      
      <MerchantSiteHeader/>
      
      <div className='container-fluid p-0' style={{backgroundColor:"#FBFBFB"}}>
        <div className='container ps-lg-4 mb-0 py-2'>
          <p className='ps-lg-3 mb-0'><NavLink to='/' style={{textDecoration:'none',color:'#000000b6'}}>Home/</NavLink> Stores/<span className='fw-bold'> {logoData ? logoData.storeName+"/": "Brand/"}</span></p>
        </div>
      </div>
      {/* <MerchantSiteNav style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1000 }} /> */}
      <div className='container p-0'>
        { logoData ? 
          <img src={`data:image/jpeg;base64,${logoData?.heroBannerImage}`} className='img-fluid' style={{ width: "100%" }}/>
          :
          <img src="/images/top.jpg" className='img-fluid' style={{ width: "100%" }}/>
        }
          <div >
            <MerchantSiteNav/>
          </div>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.section`
// .sticky-wrapper {
//   position: sticky;
//   top: 0;
//   z-index: 1000;
//   background: white;
// }
`;

export default MerchantSite